import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem('token');
    try {
      sessionStorage.removeItem('theme_effect_disabled');
    } catch {}
    navigate('/login', { replace: true });
  }, [navigate]);

  return <p>Logout...</p>;
}
